import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type { TRemotePaymentMethod } from '../../store/types';

export const convertRemoteMethodsToTable = (items: TRemotePaymentMethod[]): TRemotePaymentMethod[] => {
  const shops = items.map((item) => ({
    ...item,
    created: dayjsCustom(item.created).format('DD.MM.YYYY / HH:mm'),
  }));

  return shops;
};
